import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Ngay khi trang vừa định mở lên, kiểm tra LocalStorage ngay
    const token = localStorage.getItem('accessToken');
    
    // Nếu không có token, đá thẳng về Login
    if (!token) {
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  // Nếu có token thì mới cho phép hiển thị nội dung bên trong (children)
  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;